import { lazy } from "react";

export { COMPANY_PATH as COMPANY_STRUCTURE_PATH } from "./main-path";
export const Main = lazy(
  () => import(/* webpackChunkName: "company-structure" */ "./ui/main"),
);
